export default __webpack_public_path__ + "static/media/gridImg4.8518dbeb.jpg";